import WithRender from "../../templates/imageEditorGalleries/imageEditorGalleries.html";
import { mapGetters } from "vuex";
import { Tabs, Tab } from "vue-tabs-component";

import ImageEditorLocalImages from "../imageEditorGalleries/ImageEditorLocalImages";
import ImageEditorUploadedImages from "../imageEditorGalleries/ImageEditorUploadedImages";

export default WithRender({
  components: {
    tabs: Tabs,
    tab: Tab,
    appImageEditorLocalImages: ImageEditorLocalImages,
    appImageEditorUploadedImages: ImageEditorUploadedImages
  },
  computed: {}
});
